import screenExample1 from './images/screenExample1.png';
import screenExample2 from './images/screenExample2.png';
import screenExample3 from './images/screenExample3.png';
import screenExample4 from './images/screenExample4.png';
import screenExample5 from './images/screenExample5.png';
import screenExample6 from './images/screenExample6.png';

/** Real INVERT screen installations — shared across marketing surfaces. */
export const INSTALLATION_SHOTS = [
    { src: screenExample1, alt: 'INVERT screen installation in a retail venue' },
    { src: screenExample2, alt: 'INVERT display with in-venue messaging' },
    { src: screenExample3, alt: 'INVERT wall-mounted screen in a business' },
    { src: screenExample4, alt: 'INVERT screen showing mixed venue content' },
    { src: screenExample5, alt: 'INVERT portrait display in a storefront' },
    { src: screenExample6, alt: 'INVERT large-format screen installation' },
];
